<template>
    <div class="container">
        <search-form></search-form>
        <banner/>
        <live-item></live-item>
    </div>
</template>

<script>
  import SearchForm from "../components/education/search-form"
  import Banner from "../components/education/banner"
  import LiveItem from "../components/education/live-item"

  export default {
    name: "Education",
    data() {
      return {}
    },
    computed: {},
    components: {SearchForm, Banner, LiveItem},
    mixins: [],
    created() {
    },
    mounted() {
    },
    watch: {},
    methods: {},
  }
</script>

<style scoped lang="scss">

</style>
